import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { prevent } from '../../../data/snak2';
interface PreventScreenProps {
  /** Shown only when this instalment runs as a standalone campaign. */
  onRestart?: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function PreventScreen({
  onRestart
}: PreventScreenProps) {
  return <div className="flex flex-1 flex-col" data-id="element-320" data-mp="3bu6ad06h8sp3">
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="text-[9.5px] uppercase tracking-micro text-ozBlue" data-id="element-321" data-mp="3bv7jgz3xn546">
        {prevent.label}
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.06,
      ease: EASE
    }} className="mt-3 font-display text-[26px] font-semibold leading-[1.05] tracking-tight text-ozNavy" data-id="element-322" data-mp="3gtsodbu4qcyy">
        {prevent.headline[0]}
        <br data-id="element-323" data-mp="2mww1iqptwqi6" />
        {prevent.headline[1]}
      </motion.h2>

      <p className="mt-3.5 text-[12.5px] leading-relaxed text-mut" data-id="element-324" data-mp="2mu9vwwmi0l2l">{prevent.lead}</p>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.16,
      ease: EASE
    }} className="mt-4 rounded-xl border-l-[3px] border-ozGreen bg-ozMist px-4 py-3.5" data-id="element-325" data-mp="2rtmgfapwdg20">
        <p className="font-display text-[16px] font-semibold leading-none tracking-tight text-ozNavy" data-id="element-326" data-mp="23y1phphr245p">
          {prevent.productName}
        </p>
        <p className="mt-1 text-[10px] uppercase tracking-micro text-ozBlue" data-id="element-327" data-mp="28wv0nb9kdj2p">
          {prevent.productDescriptor}
        </p>
        <p className="mt-2.5 text-[11.5px] leading-snug text-mut" data-id="element-328" data-mp="2hx9p2jhtreaf">{prevent.productLine}</p>
      </motion.div>

      <ul className="mt-4 flex flex-col gap-1.5" data-id="element-329" data-mp="3odln8kkncw60">
        {prevent.points.map((point, i) => <motion.li key={point} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        delay: 0.22 + i * 0.05,
        ease: EASE
      }} className="flex gap-2.5 text-[11.5px] leading-snug text-ozNavy" data-id="element-330" data-mp="3tc6gu15e8hlh" data-mpi={i}>
            <span className="mt-[6px] h-1.5 w-1.5 shrink-0 rounded-full bg-ozGreen" aria-hidden="true" data-id="element-331" data-mp="2384hyfq2g2wm" />
            {point}
          </motion.li>)}
      </ul>

      <p className="mt-3 text-[9.5px] leading-snug text-mut" data-id="element-332" data-mp="1aj60lktrp4sd">{prevent.spc}</p>

      <div className="mt-auto pt-5" data-id="element-333" data-mp="15kmd3fzizkxw">
        <a href="#case-review" className="flex items-center gap-3 rounded-xl bg-ozNavy px-4 py-3 transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ozBlue focus-visible:ring-offset-2" data-id="element-334" data-mp="15lnojlkge9g5">
          <span className="min-w-0 flex-1" data-id="element-335" data-mp="rsy1ddt6uyhg">
            <span className="block text-[12.5px] font-semibold leading-snug text-paper" data-id="element-336" data-mp="rrmwfao0bkor">
              {prevent.ctaLabel}
            </span>
            <span className="mt-0.5 block text-[10.5px] leading-snug text-ozMist" data-id="element-337" data-mp="2yhgjep2hl7ka">
              {prevent.ctaDetail}
            </span>
          </span>
          <ArrowRightIcon className="h-4 w-4 shrink-0 text-ozGreen" aria-hidden="true" data-id="element-338" data-mp="338yit8ov3035" />
        </a>

        <p className="mt-3 rounded-lg border border-dashed border-line bg-mist px-3 py-2 text-[9px] leading-snug text-mut" data-id="element-339" data-mp="2pi395u6jgeyi">
          {prevent.internalNote}
        </p>

        {onRestart && <button type="button" onClick={onRestart} className="mx-auto mt-3 block h-9 rounded-full px-4 text-[12px] text-mut transition-colors duration-150 hover:text-ozNavy focus:outline-none focus-visible:ring-2 focus-visible:ring-ozBlue" data-id="element-340" data-mp="3h99agdxzwipd">
            Back to the start
          </button>}
      </div>
    </div>;
}